import {
    mapActions,
    mapGetters,
    mapMutations
} from 'vuex';
import CommandesI18n from './Commandes.i18n.js';

export default {

    components: {},

    props: {},

    computed: {
        ...mapGetters(['devisLoading', 'devis', 'isDownloading'])
    },

    data() {
        return {
            currentCode: ''
        };
    },

    watch: {},

    methods: {
        ...mapActions(['getDevis', 'downloadFacture']),

        /**
         * Fonction pour télécharger la facture d'un devis 
         * @param {*} pDevisId 
         */
        downloadSelectedFacture(pDevisId) {
            this.currentCode = pDevisId
            const codeDevis = {
                ListeCodeEnteteDevis: [pDevisId]
            }
            this.downloadFacture(codeDevis).then(res => {
                //this.$refs['downloading'].hide()
            }).catch(err => {
                console.log(err)
                this.notify('error', 'Erreur', "La facture n'a pas pu être téléchargée. Veuillez réessayer plus tard.")
            })

        }

    },

    filters: {
        formatType: (pType) => {
            if (pType === 'F') {
                return 'Fleurs'
            } else {
                return 'Plaques'
            }
        },

        formatNumber: (pValue) => {
            return parseFloat(pValue).toLocaleString('fr-FR', {style: "currency", currency: "EUR"})
        },

        formatDate: (pDate) => {
            let date = new Date(pDate)
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            }
            return date.toLocaleDateString('fr-FR', options)
        }
    },

    mounted() {
        this.getDevis().then(res => {}).catch(err => {
            console.log(err)
            this.notify('error', 'Erreur', 'Impossible de récupérer les devis. Veuillez réessayer plus tard.')
        })
    },

    i18n: CommandesI18n,

};
